import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, Button, Spinner, Alert, Container, Pagination } from "react-bootstrap";
import { callEndpoint } from "../ApiCall";
import { FaEdit, FaEye } from "react-icons/fa";
// import LogoImage from '../images/logo.png';

const List = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Number of items per page
  const history = useHistory();

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const body = {
          col: ["id", "name"],
          filter: [["park", "=", "0"]],
          table: "form",
          offset: (currentPage - 1) * pageSize, // Calculate the offset
          limit: pageSize, // Number of items per page
        };
        // console.log(body);
        const endpoint = "settingRoute.php";
        const action = "getSetting";
        const response = await callEndpoint(body, endpoint, action);
        if (response?.data?.length > 0) {
          setForms(response.data);
          const count = response.count;
        //   handlePageSizeChange(response.count)
        } else {
          setForms([]);
        }
      } catch (err) {
        setError("An error occurred while fetching the forms.");
      } finally {
        setLoading(false);
      }
    };

    fetchForms();
  }, [currentPage, pageSize]); // Re-fetch data when page or pageSize changes

  const handleNavigate = (action, formId) => {
    const routes = {
      view: `/submission?fid=${formId}`,
      edit: `/Edit?id=${formId}`,
    };
    history.push(routes[action] || "/");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center mt-5">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <strong>Error:</strong> {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <div>
        {/* <img className="topCenter" src={LogoImage} alt="logo" /> */}
      </div>
      <h1 className="text-center mb-4">Form List</h1>
      {forms.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {forms.map((form) => (
              <tr key={form.id}>
                <td>{form.id}</td>
                <td>{form.name}</td>
                <td>
                  <Button
                    variant="primary"
                    size="sm"
                    className="mr-2"
                    onClick={() => handleNavigate("view", form.id)}
                  >
                    <FaEye />
                  </Button>

                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => handleNavigate("edit", form.id)}
                  >
                    <FaEdit />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="info" className="text-center">
          No forms available in the table!
        </Alert>
      )}

      {/* Pagination Component */}
      <div className="d-flex justify-content-center">
        <Pagination>
          <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
          {/* Dynamic page numbers */}
          {[...Array(5)].map((_, idx) => {
            const page = currentPage + idx - 2; // Display 5 pages around the current page
            if (page > 0) {
              return (
                <Pagination.Item
                  key={page}
                  active={page === currentPage}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </Pagination.Item>
              );
            }
            return null;
          })}
          <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} />
        </Pagination>
      </div>
    </Container>
  );
};

export default List;
